import { Instagram, Mail } from "lucide-react";
import { getShopifyCollectionUrl } from "@/lib/shopify";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="contact" className="bg-stone-950 border-t border-stone-800/60 text-stone-300">
      <div className="container-luxury py-16 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-12 mb-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <h3 className="font-display text-2xl font-bold mb-4 text-[#F4EFE6]">UNIXORN</h3>
            <p className="text-stone-400 text-sm leading-relaxed">
              Unique & Original<br />
              Luxury streetwear for individuals who stand apart.
            </p>
          </div>

          {/* Shop */}
          <div>
            <h4 className="font-display font-semibold mb-4 text-[#F4EFE6] uppercase tracking-wide text-sm">Shop</h4>
            <nav className="flex flex-col space-y-3">
              <a href={getShopifyCollectionUrl("crowns")} className="text-stone-400 text-sm hover:text-[#F4EFE6] transition-colors">Crowns</a>
              <a href={getShopifyCollectionUrl("classics")} className="text-stone-400 text-sm hover:text-[#F4EFE6] transition-colors">Classics</a>
              <a href={getShopifyCollectionUrl("tracksuits")} className="text-stone-400 text-sm hover:text-[#F4EFE6] transition-colors">Tracksuits</a>
              <a href={getShopifyCollectionUrl("tshirts")} className="text-stone-400 text-sm hover:text-[#F4EFE6] transition-colors">T-Shirts</a>
              <a href={getShopifyCollectionUrl("all")} className="text-stone-400 text-sm hover:text-[#F4EFE6] transition-colors">Shop All</a>
            </nav>
          </div>

          {/* Explore */}
          <div>
            <h4 className="font-display font-semibold mb-4 text-[#F4EFE6] uppercase tracking-wide text-sm">Explore</h4>
            <nav className="flex flex-col space-y-3">
              <a href="/" className="text-stone-400 text-sm hover:text-[#F4EFE6] transition-colors">Home</a>
              <a href="/footwear" className="text-stone-400 text-sm hover:text-[#F4EFE6] transition-colors">Footwear</a>
              <a href="/chronicles" className="text-stone-400 text-sm hover:text-[#F4EFE6] transition-colors">Archive</a>
              <a href="/about" className="text-stone-400 text-sm hover:text-[#F4EFE6] transition-colors">About</a>
              <a href="/faq" className="text-stone-400 text-sm hover:text-[#F4EFE6] transition-colors">FAQ</a>
            </nav>
          </div>

          {/* Connect */}
          <div>
            <h4 className="font-display font-semibold mb-4 text-[#F4EFE6] uppercase tracking-wide text-sm">Connect</h4>
            <div className="flex space-x-4">
              <a
                href="https://instagram.com/unixornworldwide"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-stone-700 hover:border-[#F4EFE6] hover:text-[#F4EFE6] transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="mailto:info@unixornworldwide.com"
                className="w-10 h-10 flex items-center justify-center border border-stone-700 hover:border-[#F4EFE6] hover:text-[#F4EFE6] transition-colors"
                aria-label="Email"
              >
                <Mail className="h-5 w-5" />
              </a>
            </div>
            <p className="text-stone-400 mt-4 text-xs break-all">
              info@unixornworldwide.com
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-stone-800/60">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-stone-500 text-sm">
              © {currentYear} UNIXORN. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-stone-500 text-sm hover:text-[#F4EFE6] transition-colors">Privacy Policy</a>
              <a href="#" className="text-stone-500 text-sm hover:text-[#F4EFE6] transition-colors">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
